module.exports = __webpack_public_path__ + "static/media/selectReturn.ad658581.png";